import styled from "styled-components";

const GreetingBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  width: 100%;
`;

const GreetingBoxTitle = styled.span`
  text-align: center;
  font-size: 1.4rem;
  color: ${props => props.color};
  font-weight: 700;
  margin-bottom: 1rem;
`;

const GreetingBoxDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 2rem;
`;

const GreetingBoxValue = styled.span`
  font-size: 1rem;
  text-align: center;
  color: ${props => props.theme.colors.colorSecondary};
  font-weight: 600;
`;

const Avatar = styled.div`
  & svg.greeting-box-avatar {
    background-color: transparent;
    height: 5.3rem;
    margin: 0 auto;
    width: 5.3rem;
    margin: 1.6rem 0;
  }
`;

export {
  GreetingBoxWrapper,
  GreetingBoxDetails,
  GreetingBoxTitle,
  GreetingBoxValue,
  Avatar
};
